import { combineReducers } from 'redux';

import agreedToTerms from './agreedToTerms';
import chosenLeaseCar from './chosenLeaseCar';
import customerDataFilledFromLogin from './customerDataFilledFromLogin';
import isFlex from './isFlex';
import isOccasion from './isOccasion';
import isPricePointSetFromCookie from './isPricePointSetFromCookie';
import leaseCarData from './leaseCarData';
import plCustomer from './plCustomer';
import remarks from './remarks';

const rootReducer = combineReducers({
	plCustomer,
	leaseCarData,
	chosenLeaseCar,
	remarks,
	agreedToTerms,
	isOccasion,
	isFlex,
	isPricePointSetFromCookie,
	customerDataFilledFromLogin,
});

export default rootReducer;
